import React, { Component } from 'react';
import { connect } from 'react-redux';
import { sensorsConnect, 
         sensorsDisconnect } from '../../store/actions';
import { withRouter } from 'react-router-dom';

import Sensors from '../../components/Sensors';

class Csensors extends Component{
    constructor(props){
        super(props);

        this.state = {};
    }

    componentDidMount(){        
        this.props.sensorsConnect();
    }

    componentWillUnmount(){
        this.props.sensorsDisconnect();
    }

    render(){
        return (
            <Sensors 
                sensors={this.props.sensors}

                texts= {{
                    gps: this.props.txt_gps,
                    lat: this.props.txt_lat,
                    long: this.props.txt_long,
                    name: this.props.txt_name,
                    nosensors: this.props.txt_nosensors,
                    sensors: this.props.txt_sensors,
                    speed: this.props.txt_speed,
                    volt: this.props.txt_volt,
                    temp: this.props.txt_temp,
                    uin: this.props.txt_uin,
                    tsensors: this.props.txt_tsensors,
                    type: this.props.txt_type
                }}
            />
        );
    }
}

const mapStateToProps = state => {
    const getText = (id) => {
        let text = '';
        try {
            text = state.app.texts[id][state.app.language];
        } catch (err) {
            text = '';
        }
        return text;
    }

    return {
        sensorsState: state.sensors.sensorsState,
        sensors : state.sensors.sensors,

        txt_gps : getText("0009"),
        txt_lat : getText("0010"),
        txt_long : getText("0011"),
        txt_name : getText("0037"),
        txt_nosensors : getText("0017"),
        txt_sensors : getText("0007"),
        txt_speed : getText("0012"),
        txt_sampleid : getText("0013"),
        txt_temp : getText("0015"),
        txt_tsensors : getText("0039"),
        txt_type : getText("0040"),
        txt_uin : getText("0038"),
        txt_volt : getText("0014")
    }
}

const mapDispatchToProps = dispatch => {
    return {
        sensorsConnect: () => dispatch(sensorsConnect()),
        sensorsDisconnect: () => dispatch(sensorsDisconnect())
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Csensors));



// WEBPACK FOOTER //
// ./src/containers/Csensors/index.js